import styled from 'styled-components';

export const StyledMachineDetailsRobotCleaningData = styled.div`
  min-height: inherit;
`;
